const ANNUAL_PRICE_CURRENCIES = ['AED', 'AUD', 'HKD', 'INR', 'ZAR'];
export function shouldSeeAnnualBundlePlan(currency: string): boolean {
  return ANNUAL_PRICE_CURRENCIES.includes(currency);
}
